module.exports = __webpack_public_path__ + "img/572-42dfb3.png";